const $str = window.$str

/**
 * 电价维护：工业类型 industry 的唯一定义（避免多层“转来转去”）
 *
 * 全模块 industry 的展示、筛选、保存、导出必须走本文件方法，不要手写 0/1 含义。
 *
 * 后端 industry（仅两档）：
 * - 0：一般工商业
 * - 1：大工业
 *
 * 另：type 为用电方式（与 industry 无关）——0 单一制；1 两部制
 */

export function industryKeyFromValue(industry) {
  if (industry === 0 || industry === '0') return 'generalBusiness'
  if (industry === 1 || industry === '1') return 'bigIndustry'
  return ''
}

export function systemKeyFromValue(type) {
  if (type === 0 || type === '0') return 'single'
  if (type === 1 || type === '1') return 'twoPart'
  return ''
}

export function industryLabelFromValue(industry) {
  const k = industryKeyFromValue(industry)
  if (k === 'generalBusiness') return $str.getKey('收益管理/一般工商业')
  if (k === 'bigIndustry') return $str.getKey('收益管理/大工业')
  return '-'
}

export function systemLabelFromValue(type) {
  const k = systemKeyFromValue(type)
  if (k === 'single') return $str.getKey('收益管理/单一制')
  if (k === 'twoPart') return $str.getKey('收益管理/两部制')
  return '-'
}

export function industryValueFromFormKey(key) {
  // industry: 0 一般工商业；1 大工业
  if (key === 'generalBusiness') return 0
  if (key === 'bigIndustry') return 1
  return undefined
}

export function typeValueFromSystemKey(key) {
  // type: 0 单一制；1 两部制
  if (key === 'single') return 0
  if (key === 'twoPart') return 1
  return undefined
}

/** 页头/历史筛选用的「电价类型」：与后端 priceType 一致 — 1 代理购电；2 现货；3 充电桩 */
export function businessPriceTypeNumFromEntryKey(key) {
  // 最新约定：1 代理购电；2 充电桩；现货不传 priceType
  if (key === 'chargePile') return 2
  if (key === 'proxy') return 1
  return undefined
}

